<script>
import * as d3 from "d3";
import jQuery from "jquery";

import {
    onMount
} from "svelte";

export let obj;
export let maxWidth;


let width = 500;
let height = 500;


// Canvas size retrieves the same size as the SVG which is responsive
//let widthCanvas = parseInt(d3.select(".figure").style("width").slice(0, -2));
//let heightCanvas = parseInt(d3.select(".figure").style("height").slice(0, -2));




const t = d3.transition()
    .duration(2000);

onMount(() => {

    // canvas setup
    const dpi = 3;

		const windowW = jQuery(".container").width();
		console.log("window", windowW);
		const maxW = parseInt(maxWidth.slice(0,-2));



    // canvas setup
    /*
     */

		function parsing(x) {
			x = x.replace(/\s+/g,"_").replace("'","").replace(":","").replace("é","e").toLowerCase();
			return x
			}

		let movieSim = parsing(obj.movie);

    const dataset = d3.json(`./data/${movieSim}.json`);

    dataset.then(function(data) {

        function drawBarsRandom() {
            const svg = d3.select(".figure")
                .append("svg")
                .attr("viewBox", `0 0 ${width} 350`)
								.attr("width", () => windowW < maxW ? `${windowW}px` : `${maxW}px` )
                .style("max-width", maxWidth)
                .style("overflow", "visible");


            console.log("bars", d3.select(".figure").style("width"), svg.style("width"));

            const ratio = width / data.length;

            const fig = svg.append("g")
                //.attr("transform", `translate(0 ${height/2})`)	
                .attr("transform", `translate(0 0)`)

            fig.selectAll("rect")
                .data(data)
                .join("rect")
                .attr("x", (d, i) => i * ratio)
                //.attr("y", (d,i) => -100 + Math.random()*50)
                .attr("y", 40)
                .attr("width", 1)
                .attr("height", height/2)
                .attr("fill", (d, i) => `hsl(${d[0][0]}, ${d[0][1]}%, ${d[0][2]}%)`)
                .attr("fill-opacity", 1)

        }

        function drawCircle() {
						const svg = d3.select(".figure")
                .append("svg")
								.attr("viewBox", `0 0 ${width} ${height}`)
								.attr("width", () => windowW < maxW ? `${windowW}px` : `${maxW}px` )
                .style("max-width", maxWidth)
                .style("overflow", "visible");


						//
            const radius = 50;

            const ratio = width / data.length;

            const scaleAngle = d3.scaleLinear()
                .domain([0, data.length - 1])
                .range([-Math.PI/2, (Math.PI * 2) - Math.PI/2])

            const lines = svg.append("g")
            //.attr("transform", `translate(0 ${height/2})`)

            lines.selectAll("line")
                .data(data)
                .join("line")
                .attr("stroke", (d, i) => `hsl(${d[0][0]}, ${d[0][1]}%, ${d[0][2]}%)`)
                .attr("stroke-width", 2)
                .attr("transform", `translate(${width/2},${height/2})`)
                .attr("x1", (d, i) => radius * Math.cos(scaleAngle(i)))
                .attr("y1", (d, i) => radius * Math.sin(scaleAngle(i)))
                .attr("x2", (d, i) => (radius + 150) * Math.cos(scaleAngle(i)))
                .attr("y2", (d, i) => (radius + 150) * Math.sin(scaleAngle(i)))
                .attr("stroke-opacity", 1)
        }

        function drawSphere() {
						const svg = d3.select(".figure")
                .append("svg")
								.attr("viewBox", `0 0 ${width} ${height}`)
								.attr("width", () => windowW < maxW ? `${windowW}px` : `${maxW}px` )
                .style("max-width", maxWidth)
                .style("overflow", "visible");

            console.log(svg.width);
            const ratio = width / data.length;

            const spheres = svg.append("g")

            spheres.selectAll("circle")
                .data(data)
                .join("circle")
                .attr("cx", width / 2)
                .attr("cy", height / 2)
                .attr("r", (d, i) => ratio * i / 3)
                .attr("fill", "#0000")
                .attr("stroke", (d, i) => `hsl(${d[0][0]}, ${d[0][1]}%, ${d[0][2]}%)`)
                .attr("stroke-width", ratio)
                .attr("stroke-opacity", 1)
        }


        function drawTurb() {

            let drawCanvas = async () => {

                // fetching svg dimensions
								const svg = d3.select(".figure")
                .append("svg")
								.attr("viewBox", `0 0 ${width} ${height}`)
								.attr("width", () => windowW < maxW ? `${windowW}px` : `${maxW}px` )
                .style("max-width", maxWidth)
                .style("overflow", "visible");

               
                let W = parseInt(d3.select(".figure").style("width").slice(0, -2));
                let H = parseInt(d3.select(".figure").style("height").slice(0, -2));

                svg.remove();
                // --- end of fetching

                let dims = {
                    "W": W,
                    "H": H
                };

                return dims
            }
            drawCanvas().then(function(dims) {
                let myCanvas = document.getElementById("myFig");

                myCanvas.style.width = `${dims.W}px`;
                myCanvas.style.height = `${dims.H}px`;

								d3.select("#myFig").append("img")
									.attr("class", "img-fluid")
									.attr("src", `./img/${movieSim}_min.png`);
            });

        }

				function drawWaves() {

            let drawCanvas = async () => {

                // fetching svg dimensions
								const svg = d3.select(".figure")
                .append("svg")
								.attr("viewBox", `0 0 ${width} ${height}`)
								.attr("width", () => windowW < maxW ? `${windowW}px` : `${maxW}px` )
                .style("max-width", maxWidth)
                .style("overflow", "visible");


                let W = parseInt(d3.select(".figure").style("width").slice(0, -2));
                let H = parseInt(d3.select(".figure").style("height").slice(0, -2));

                svg.remove();
                // --- end of fetching

                let dims = {
                    "W": W,
                    "H": H
                };

                return dims
            }
            drawCanvas().then(function(dims) {
                let myCanvas = document.getElementById("myFig");

                myCanvas.style.width = `${dims.W}px`;
                myCanvas.style.height = `${dims.H}px`;

								d3.select("#myFig").append("img")
									.attr("class", "img-fluid")
									.attr("src", `./img/v2_${movieSim}.png`);
            });

        }


        if (obj.graph === "spheres") {
            drawSphere();
        } else if (obj.graph === "circles") {
            drawCircle();
        } else if (obj.graph === "turb") {
            drawTurb();
        } else if (obj.graph === "waves") {
            drawWaves();
        } else {
            drawBarsRandom();
        }
    });

});
</script>

<div id="myFig" class="figure">
</div>

<style>
</style>
